<template>
  <hi-list :items="campaignList" @select="select">
    <template v-slot="{ item }">
      <v-list-item-content>
        <edm-campaign-summary :campaign="item"></edm-campaign-summary>
      </v-list-item-content>
    </template>
  </hi-list>
</template>

<script>
import HiList from "@/components/HiList";
import { mapActions, mapGetters } from "vuex";
import EdmCampaignSummary from "@/components/edm/EdmCampaignSummary";

export default {
  name: "EdmCampaignList",
  components: { EdmCampaignSummary, HiList },
  data() {
    return {
      // campaignList: [],
      selected: null
    };
  },
  methods: {
    select(item) {
      console.log(item);
      // this.$emit("select", item);
      this.setCurrentCampaign(item.id);
      this.$router.replace({ path: `/edm/campaign/${item.id}` });
    },
    ...mapActions("edm", ["setCurrentCampaign"])
  },
  computed: {
    ...mapGetters("edm", ["campaignList"]),
    counts(item) {
      return item.counts || {};
    }
  }
};
</script>

<style scoped></style>
